import userReducer from './userReducer'
import projectReducer from './projectReducer'
import studioReducer from './studioReducer'
import reservationReducer from './reservationReducer'
import widgetReducer from './widgetReducer'
import instructorReducer from './instructorReducer'
import schedulingReducer from './schedulingReducer';
import festivalReducer from './festivalReducer';
import clientsReducer from './clientsReducer'
import connectionsReducer from './connectionsReducer'
import { combineReducers } from 'redux'

const appReducer = combineReducers({
    user: userReducer,
    project: projectReducer,
    studio: studioReducer,
    reservation: reservationReducer,
    widget: widgetReducer,
    instructor: instructorReducer,
    scheduling: schedulingReducer,
    festival: festivalReducer,
    clients: clientsReducer,
    connections: connectionsReducer
})

const rootReducer = (state, action) => {
    if (action.type === 'RESET_APP') {
        state = undefined;
    }
    
    return appReducer(state, action);
}

export default rootReducer